"use client";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { OptionsContext, SearchOptions } from "@/provider/options-provider";
import { useContext } from "react";

export function SearchOptionCheckbox(props: {
  id: string;
  label: string;
  description: string;
}) {
  const { searchOptions, setSearchOptions } = useContext(OptionsContext);
  return (
    <div className="items-top my-2 flex flex-col rounded-md p-2 ring-1 ring-slate-200">
      <div className="flex flex-row items-center">
        <Checkbox
          id={props.id}
          checked={
            searchOptions.switches[props.id as keyof SearchOptions["switches"]]
          }
          onCheckedChange={(checked) => {
            setSearchOptions({
              ...searchOptions,
              switches: {
                ...searchOptions.switches,
                [props.id]: checked,
              },
            });
          }}
        />
        <Label
          htmlFor={props.id}
          className="ml-1 text-xs leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {props.label}
        </Label>
      </div>
      <div className="mt-1 grid gap-1.5 leading-none">
        <p className="text-xs text-muted-foreground">{props.description}</p>
      </div>
    </div>
  );
}
